/* eslint-disable */
import React, { useCallback, useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import qs from 'qs'
import { Tabs, Button, Modal, Avatar, Table, Tag, Breadcrumb, Divider } from 'antd'
import * as actions from '@/models/mgroups/actions'
import * as selectors from '@/models/mgroups/selectors'
import styles from './mgroups.module.scss'
import MgroupsDialog from '@/components/dialogs/MgroupsDialog'

function getColumns({ fetch }) {
  const dispatch = useDispatch()

  const showManagerExtDialog = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.showInfoDialog({
      mgroups: item,
      title: '编辑分组',
      ismodify: "modify",
      submitCallback: () => { fetch() }
    }))
  })
  const deleteManager = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.setActiveState(item._id, !item.isDelete))
  })
  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '分组',
      render: item => (
        <div>
          <div>{item.name}</div>
        </div>
      )
    },
    {
      title: '描述',
      render: item => (
        <div>
          <div>{item.desc}</div>
        </div>
      )
    },
    {
      title: '创建时间',
      render: item => (
        <div>
          {item.createdAt ? dayjs(item.createdAt).fromNow() : '-'}
        </div>
      )
    },

    {
      title: '操作',
      render: item => {
        return (
          <div>
            <a onClick={showManagerExtDialog(item)}>编辑</a>
            <Divider type="vertical" />
            <a onClick={deleteManager(item)}>删除</a>
          </div>
        )
      }
    }
  ]
}

function MgroupsList(props, ref) {
  const dispatch = useDispatch()

  const loading = useSelector(selectors.loadingSelector)
  const total = useSelector(selectors.totalSelector)
  const mgroups = useSelector(selectors.entriesSelectors)

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);

  useImperativeHandle(ref, () => ({
    add() {
      showInfoDialog('添加分组')
    },
  }));

  const pagination = {
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }
  const fetch = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    dispatch(actions.fetchList(params))
  }, [])
  const showInfoDialog = (title) => {
    dispatch(actions.showInfoDialog({
      title,
      mgroups: {},
      submitCallback: () => { fetch() }
    }))
  }

  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    fetch(nextQuery)
  })

  const columns = getColumns({ fetch })

  useMount(() => {
    fetch()
  })

  return (
    <div className={styles.container}>
      {/* <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>客服分组</Breadcrumb.Item>
          <Breadcrumb.Item>列表</Breadcrumb.Item>
        </Breadcrumb>
        <Button size="small" onClick={() => { showInfoDialog('添加分组') }}>添加分组</Button>
      </div> */}
      <Table
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={mgroups.toJS()}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}></Table>
      <MgroupsDialog type="manager" />
    </div>
  )
}

export default forwardRef(MgroupsList)
